var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"outlined":"","dismissible":"","value":_vm.isAlert,"color":_vm.color}},_vm._l((_vm.messages),function(item,index){return _c('div',{key:("message_" + index)},[_c('div',{domProps:{"innerHTML":_vm._s(item)}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }